import React from "react";
import PropTypes from "prop-types";
import Snackbar from "@mui/material/Snackbar";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";

import styles from "./CustomBannerStyles";
import { SHOW_DEFAULT_TOAST_DURATION } from "../../consts/toastShowDuration";

const CustomBanner = ({
  customToastStyle,
  hideDuration = SHOW_DEFAULT_TOAST_DURATION,
  openSnackbar,
  onClose,
  severity,
  snackbarMessage,
}) => {
  const isError = severity === "error";

  const handleOnClose = (event, reason) => {
    if (isError && reason === "clickaway") return;
    onClose(event, reason);
  };

  return (
    <Snackbar
      open={!!openSnackbar}
      {...(!isError && { autoHideDuration: hideDuration })}
      onClose={handleOnClose}
      message={snackbarMessage}
      anchorOrigin={{ vertical: "top", horizontal: "center" }}
      action={
        isError ? (
          <IconButton
            size="small"
            onClick={onClose}
            sx={{
              color: "red",
              flexShrink: 0,
              marginLeft: "auto",
              alignSelf: "center",
            }}
          >
            <CloseIcon fontSize="small" />
          </IconButton>
        ) : null
      }
      ContentProps={{
        sx: {
          ...styles.commonToastMessage,

          "& .MuiSnackbarContent-message": {
            padding: 0,
            flex: 1,
            display: "flex",
            alignItems: "center",
          },

          "& .MuiSnackbarContent-action": {
            padding: 0,
            marginLeft: "16px",
            alignSelf: "center",
          },

          ...(severity === "success"
            ? styles.toastSuccessMessage
            : isError
              ? styles.toastErrorMessage
              : styles.toastMessage),
          ...customToastStyle,
        },
      }}
    />
  );
};

CustomBanner.propTypes = {
  customToastStyle: PropTypes.object,
  hideDuration: PropTypes.number,
  openSnackbar: PropTypes.bool,
  onClose: PropTypes.func,
  severity: PropTypes.string,
  snackbarMessage: PropTypes.string,
};

export default CustomBanner;
